import { useState } from 'react'; // Added this import
import { useNavigate } from 'react-router-dom';
import Cart from '../../OldRydercup/pages/Cart';
import { submitOrder } from '../../services/magento/api';
import '../styles/ConfirmationPage.css';

const ConfirmationPage = ({ userInfo, cart, resetCart, products }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  
  const handleSubmit = async () => {
    setIsSubmitting(true);
    setError(null);
    
    try {
      const orderData = {
        userInfo,
        cart,
        total: calculateTotal(cart, products)
      };
      
      await submitOrder(orderData);
      resetCart();
      navigate('/success'); // You would create a SuccessPage component
    } catch (err) {
      setError('Failed to submit order. Please try again.');
      setIsSubmitting(false);
    }
  };
  
  const calculateTotal = (cart, products) => {
    let total = 0;
    
    if (cart.bundle) {
      const bundle = products.bundles.find(b => b.id === cart.bundle.id);
      total += bundle.price;
    }
    
    [cart.firstChoice, cart.secondChoice, cart.thirdChoice].forEach(item => {
      if (item) total += item.price;
    });
    
    return total;
  };

  return (
    <div className="confirmation-page">
      <h2>Review Your Order</h2>
      
      <Cart cart={cart} products={products} editable />
      
      <div className="user-info">
        <h3>Shipping Information</h3>
        <p>{userInfo.name}</p>
        <p>{userInfo.address}</p>
        <p>{userInfo.email}</p>
        <p>{userInfo.phone}</p>
      </div>
      
      {error && <div className="error">{error}</div>}
      
      <button 
        onClick={handleSubmit} 
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Submitting...' : 'Submit Order'}
      </button>
    </div>
  );
};

export default ConfirmationPage;